module.exports = __webpack_public_path__ + "img/u168.c82dd57f.jpg";